/**
 * @generated SignedSource<<59d3ab5850892cb433979868803b1f20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraPullRequestState = "DECLINED" | "DRAFT" | "MERGED" | "OPEN" | "%future added value";
export type JiraReviewState = "APPROVAL" | "CLOSED" | "DEAD" | "DRAFT" | "REJECTED" | "REVIEW" | "SUMMARIZE" | "UNKNOWN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type development_softwareReleasesVersionDetailIssueList$data = {
  readonly devSummaryCache: {
    readonly devSummary: {
      readonly branch: {
        readonly overall: {
          readonly count: number;
        };
      };
      readonly commit: {
        readonly overall: {
          readonly count: number;
        };
      };
      readonly pullrequest: {
        readonly overall: {
          readonly count: number;
          readonly state: JiraPullRequestState | null | undefined;
        };
      };
      readonly review: {
        readonly overall: {
          readonly count: number;
          readonly lastUpdated: AGG$DateTime | null | undefined;
          readonly state: JiraReviewState | null | undefined;
          readonly stateCount: number;
        };
        readonly summaryByProvider: ReadonlyArray<{
          readonly count: number | null | undefined;
          readonly name: string | null | undefined;
          readonly providerId: string | null | undefined;
        }>;
      };
    };
  };
  readonly issueId: string;
  readonly " $fragmentType": "development_softwareReleasesVersionDetailIssueList";
};
export type development_softwareReleasesVersionDetailIssueList$key = {
  readonly " $data"?: development_softwareReleasesVersionDetailIssueList$data;
  readonly " $fragmentSpreads": FragmentRefs<"development_softwareReleasesVersionDetailIssueList">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "count"
},
v1 = {
  "kind": "ScalarField",
  "name": "state"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "development_softwareReleasesVersionDetailIssueList",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "issueId"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraIssueDevSummaryResult",
        "kind": "LinkedField",
        "name": "devSummaryCache",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraIssueDevSummary",
              "kind": "LinkedField",
              "name": "devSummary",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                    "kind": "LinkedField",
                    "name": "branch",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraIssueBranchDevSummary",
                          "kind": "LinkedField",
                          "name": "overall",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v0/*: any*/),
                              "action": "THROW",
                              "path": "devSummaryCache.devSummary.branch.overall.count"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "devSummaryCache.devSummary.branch.overall"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "devSummaryCache.devSummary.branch"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                    "kind": "LinkedField",
                    "name": "commit",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraIssueCommitDevSummary",
                          "kind": "LinkedField",
                          "name": "overall",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v0/*: any*/),
                              "action": "THROW",
                              "path": "devSummaryCache.devSummary.commit.overall.count"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "devSummaryCache.devSummary.commit.overall"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "devSummaryCache.devSummary.commit"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                    "kind": "LinkedField",
                    "name": "pullrequest",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraIssuePullRequestDevSummary",
                          "kind": "LinkedField",
                          "name": "overall",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v0/*: any*/),
                              "action": "THROW",
                              "path": "devSummaryCache.devSummary.pullrequest.overall.count"
                            },
                            (v1/*: any*/)
                          ]
                        },
                        "action": "THROW",
                        "path": "devSummaryCache.devSummary.pullrequest.overall"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "devSummaryCache.devSummary.pullrequest"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                    "kind": "LinkedField",
                    "name": "review",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraIssueReviewDevSummary",
                          "kind": "LinkedField",
                          "name": "overall",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v0/*: any*/),
                              "action": "THROW",
                              "path": "devSummaryCache.devSummary.review.overall.count"
                            },
                            (v1/*: any*/),
                            {
                              "kind": "ScalarField",
                              "name": "lastUpdated"
                            },
                            {
                              "kind": "RequiredField",
                              "field": {
                                "kind": "ScalarField",
                                "name": "stateCount"
                              },
                              "action": "THROW",
                              "path": "devSummaryCache.devSummary.review.overall.stateCount"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "devSummaryCache.devSummary.review.overall"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraIssueDevSummaryByProvider",
                          "kind": "LinkedField",
                          "name": "summaryByProvider",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "providerId"
                            },
                            {
                              "kind": "ScalarField",
                              "name": "name"
                            },
                            (v0/*: any*/)
                          ]
                        },
                        "action": "THROW",
                        "path": "devSummaryCache.devSummary.review.summaryByProvider"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "devSummaryCache.devSummary.review"
                }
              ]
            },
            "action": "THROW",
            "path": "devSummaryCache.devSummary"
          }
        ]
      },
      "action": "THROW",
      "path": "devSummaryCache"
    }
  ],
  "type": "JiraIssue"
};
})();

(node as any).hash = "a6fa00d421e78b1cfca02a289c940e70";

export default node;
